import { render, staticRenderFns } from "./DocAcaoCiencia.vue?vue&type=template&id=ca4544d6&scoped=true&lang=pug&"
import script from "./DocAcaoCiencia.vue?vue&type=script&lang=js&"
export * from "./DocAcaoCiencia.vue?vue&type=script&lang=js&"
import style0 from "./DocAcaoCiencia.vue?vue&type=style&index=0&id=ca4544d6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4544d6",
  null
  
)

export default component.exports